<template>
  <div
    id="root-env"
    class="--env --ltr --light b rlt u-v .f b-c h-vh"
    style="--unit-case: 24px"
  >
    <div
      class="abs .f -pe-n -z-bg -r-i o-2"
      :style="
        'background-image: url(' +
        require('@/assets/img/icon.png') +
        '); background-size: 25px;'
      "
    ></div>

    <transition name="fade">
      <div v-if="game.state != 'STARTED'" class="fxd .f -z-3 c-20 b-c c-s">
        <div
          class="abs .f -pe-n -z-bg -r-i o-4"
          :style="
            'mix-blend-mode: saturation;background-image: url(' +
            require('@/assets/img/icon.png') +
            '); background-size: 25px;'
          "
        ></div>
        <div class="w-16 w-mx b-cl b-c">
          <img
            class="u-12 m-y-6 -r-4 rlt -z-1"
            src="@/assets/img/icon.png"
            style="mix-blend-mode: luminosity; filter: invert(90%)"
          />
          <div
            class="rlt w-f b-cl b-c e-3 -r-2 c-20 c-s -o-h"
            style="border-radius: 28px"
          >
            <div class="b-c b-j-sb p-x-5 w-f">
              <div class="u-8"></div>
              <img
                class="w-12 m-y-6 rlt -z-1"
                style="mix-blend-mode: luminosity"
                src="@/assets/img/logo.png"
              />
              <div class="u-8 b-c unt -r-c c-20-t -b" style="font-size: 14px;" @click="toggleSpeed">
                x{{ this.game.speed }}
              </div>

            </div>
            <div v-if="game.state === 'PAUSE' || game.state === 'BOOT'" class="b-cl b-c">
              <!-- <div class="abs .f -pe-n -z -r-i o-2  -g-r"  style="--g-s:#e9463a; --g-e:#f49617;"></div> -->
              <!-- <div class="abs -z .b u-f -g-b" style="--g-e: #fff"></div> -->
              <div class="w-f c-18-t rlt -z-1">
                <div class="b-j-sb itm unt p-x-4 c-s c-20-t">
                  <i class="-i">lock_open</i>
                  <span>Player</span>
                  <i class="-i">adb</i>
                </div>
                <div class="ln"></div>
                <div
                  v-for="(player, index) in game.players"
                  :key="player"
                  class="b-j-sb itm unt p-x-4"
                  :style="'--c-s: var(--' + player.pawns.config.color + ')'"
                >
                  <label class="chk u-8 b-c">
                    <input v-model="player.enabled" type="checkbox" />
                    <div class="chk-hnd">
                      <div class="hnd"></div>
                    </div>
                  </label>
                  <span>Player {{ index }}</span>
                  <label class="swt">
                    <input v-model="player.bot" type="checkbox" />
                    <div class="swt-hnd h-6 w-8 p-s-2">
                      <div class="hnd"></div>
                    </div>
                  </label>
                </div>

                <div v-if="game.state === 'BOOT'" class="p-4 m-t-4">
                  <div
                    :class="
                      (canStart ? '' : 's-d ') + 'unt w-f btn -r-4 e c-20 c-s-t'
                    "
                    @click="start"
                  >
                    <div class="-i m-e-4">gamepad</div>
                    PLAY NOW
                  </div>
                </div>
                <div v-if="game.state === 'PAUSE'" class="p-4 m-t-4">
                  <div
                    :class="
                      (canStart ? '' : 's-d ') +
                      'unt w-f btn -r-4 e CASE c-20 c-s-t'
                    "
                    @click="continueGame"
                  >
                    <div class="-i m-e-4">gamepad</div>
                    continue
                  </div>
                </div>
                <div v-if="game.state === 'PAUSE'" class="p-4 p-t-n">
                  <div
                    :class="
                      (canStart ? '' : 's-d ') +
                      'unt w-f btn-n -b -b-2 -r-4 e CASE colored-border c-20-t'
                    "
                    @click="restart"
                  >
                    <div class="-i m-e-4">refresh</div>
                    restart
                  </div>
                </div>
              </div>
            </div>
            <div v-if="game.state === 'OVER'" class="b-cl b-c">
              <!-- <div class="abs .f -pe-n -z -r-i o-2  -g-r"  style="--g-s:#e9463a; --g-e:#f49617;"></div> -->
              <!-- <div class="abs -z .b u-f -g-b" style="--g-e: #fff"></div> -->
              <div class="w-f c-18-t rlt -z-1">
                <div class="b-j-sb itm unt p-x-4 c-s c-20-t">
                  <i class="-i">military_tech</i>
                  <b>GAMEOVER!</b>
                  <i class="-i">help_center</i>
                </div>
                <div class="ln"></div>
                <div v-for="winner in game.winers" :key="winner" class="b-j-sb itm unt p-x-4 c-s c-20-t">
                  <span class="b-c u-8">{{ getPlayerRank(winner) }}</span>
                  <span>Player {{ winner }}</span>
                  <i class="-i">{{ (game.players[winner].bot?'adb':'person') }}</i>
                </div>
                <div class="p-4">
                  <div
                    :class="
                      (canStart ? '' : 's-d ') +
                      'unt w-f btn-n -b -b-2 -r-4 e CASE colored-border c-20-t'
                    "
                    @click="restart"
                  >
                    <div class="-i m-e-4">refresh</div>
                    PLAY NEW GAME
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="b-cl b-c m-t-4 o-5 c-20-t" style="font-size:10px">
            <span>made by @mohamadlounnas — ©2021</span>
            <span>Copyright ©2021 All rights reserved</span>
          </div>
        </div>
      </div>
    </transition>
    <!-- <input
          type="text"
          v-model="game.speed"
        /> -->
    <div class="b-cl" v-if="this.game">
      <!-- <div class="b">
        <div>
          <h4 class="o-7">Select pawn</h4>
          <input
            @change="
              game.players[player].pawns.list[$event.target.value] =
                game.players[player].end
            "
          />
        </div>
        <div>
          <h4 class="o-7">Select player</h4>
          <input v-model="player" />
        </div>
        <input
          type="text"
          @change="
            game.players[player].pawns.list[$event.target.value] = -(
              game.players[player].end - 6
            )
          "
        />
      </div> -->
      <nav class="h-9 b-c b-j-sb">
        <i class="-i unt -r-c u-8 b-fs" @click="pause">menu</i>
        <img class="p-3 -r-4 h-i" src="@/assets/img/icon.png" />
        <i class="-i unt -r-c u-8 b-fs">info</i>
      </nav>
      <div class="p-y-5 b b-j-sb b-a-c w-f">
        <Dice
          v-if="game.players.A.enabled"
          :enabled="player === 'A'"
          :color="game.players.A.pawns.config.color"
          :result="randemResult"
          @click="rollDice"
        ></Dice>
        <div class="h-8 w-f b-c b-j-sb">
          <i
            class="-i u-8 o-7"
            v-if="game.players.A.bot && game.players.A.enabled"
            >adb</i
          >
          <i
            class="-i u-8 o-7"
            v-if="game.players.B.bot && game.players.B.enabled"
            >adb</i
          >
        </div>
        <Dice
          v-if="game.players.B.enabled"
          :enabled="player === 'B'"
          :color="game.players.B.pawns.config.color"
          :result="randemResult"
          @click="rollDice"
        ></Dice>
      </div>
      <div class="b-cl b-c -b c-14-b -r-3">
        <div class="b-c rlt -r-i" style="margin-left: -1px">
          <div v-for="(player, playerKey) in game.players" :key="playerKey">
            <div v-if="player.enabled">
              <Pawn
                v-for="(pawn, pawnKey) in player.pawns.list"
                :key="pawnKey"
                :id="pawnKey * 1"
                :color="player.pawns.config.color"
                :player="playerKey"
                :place="pawn.toString()"
              ></Pawn>
            </div>
          </div>

          <img
            src="@/assets/img/theme-flat.png"
            class="abs .f -pe-n -z-bg -r-i"
          />
          <div
            style="
              width: calc(var(--unit-case) * 15);
              height: calc(var(--unit-case) * 15);
            "
            class="g"
          >
            <!--style="mix-blend-mode: hue;width:calc(var(--unit-case) *6); height:calc(var(--unit-case) *6);" -->
            <div
              class="b-c"
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 6);
              "
            >
              <div
                style="
                  width: calc(var(--unit-case) * 4);
                  height: calc(var(--unit-case) * 4);
                "
                class="g"
              >
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="A1"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="A2"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="A3"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="A4"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  v-if="getPlayerRank('A')"
                  style="font-size: 50px"
                  class="abs u-13 -r-4 c-20 c-orng-t o-9 b-c"
                >
                  {{ getPlayerRank("A") }}
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(var(--unit-case) * 3);
                height: calc(var(--unit-case) * 6);
              "
              class="g b-cl"
            >
              <Case :id="50"></Case>
              <Case :id="49"></Case>
              <Case :id="48"></Case>
              <Case :id="47"></Case>
              <Case :id="46"></Case>
              <Case :id="45"></Case>

              <Case :id="51"></Case>
              <Case :id="-50"></Case>
              <Case :id="-49"></Case>
              <Case :id="-48"></Case>
              <Case :id="-47"></Case>
              <Case :id="-46"></Case>

              <Case :id="52"></Case>
              <Case :id="1"></Case>
              <Case :id="2"></Case>
              <Case :id="3"></Case>
              <Case :id="4"></Case>
              <Case :id="5"></Case>
            </div>
            <div
              class="b-c"
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 6);
              "
            >
              <div
                style="
                  width: calc(var(--unit-case) * 4);
                  height: calc(var(--unit-case) * 4);
                "
                class="g"
              >
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="B1"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="B2"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="B3"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="B4"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  v-if="getPlayerRank('B')"
                  style="font-size: 50px"
                  class="abs u-13 -r-4 c-20 c-orng-t o-9 b-c"
                >
                  {{ getPlayerRank("B") }}
                </div>
              </div>
            </div>

            <div
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 3);
              "
              class="g"
            >
              <Case :id="39"></Case>
              <Case :id="40"></Case>
              <Case :id="41"></Case>
              <Case :id="42"></Case>
              <Case :id="43"></Case>
              <Case :id="44"></Case>

              <Case :id="38"></Case>
              <Case :id="-37"></Case>
              <Case :id="-36"></Case>
              <Case :id="-35"></Case>
              <Case :id="-34"></Case>
              <Case :id="-33"></Case>

              <Case :id="37"></Case>
              <Case :id="36"></Case>
              <Case :id="35"></Case>
              <Case :id="34"></Case>
              <Case :id="33"></Case>
              <Case :id="32"></Case>
            </div>
            <div
              style="
                width: calc(var(--unit-case) * 3);
                height: calc(var(--unit-case) * 3);
              "
            >
              <div class="b-c">
                <Case :id="-45"></Case>
              </div>
              <div class="b-c b-j-sb">
                <Case :id="-32"></Case>
                <Case :id="-6"></Case>
              </div>
              <div class="b-c">
                <Case :id="-19"></Case>
              </div>
            </div>
            <div
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 3);
              "
              class="g"
            >
              <Case :id="6"></Case>
              <Case :id="7"></Case>
              <Case :id="8"></Case>
              <Case :id="9"></Case>
              <Case :id="10"></Case>
              <Case :id="11"></Case>

              <Case :id="-7"></Case>
              <Case :id="-8"></Case>
              <Case :id="-9"></Case>
              <Case :id="-10"></Case>
              <Case :id="-11"></Case>
              <Case :id="12"></Case>

              <Case :id="18"></Case>
              <Case :id="17"></Case>
              <Case :id="16"></Case>
              <Case :id="15"></Case>
              <Case :id="14"></Case>
              <Case :id="13"></Case>
            </div>

            <div
              class="b-c"
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 6);
              "
            >
              <div
                style="
                  width: calc(var(--unit-case) * 4);
                  height: calc(var(--unit-case) * 4);
                "
                class="g"
              >
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="C1"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="C2"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="C3"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="C4"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  v-if="getPlayerRank('C')"
                  style="font-size: 50px"
                  class="abs u-13 -r-4 c-20 c-orng-t o-9 b-c"
                >
                  {{ getPlayerRank("C") }}
                </div>
              </div>
            </div>
            <div
              style="
                width: calc(var(--unit-case) * 3);
                height: calc(var(--unit-case) * 6);
              "
              class="g b-cl"
            >
              <Case :id="31"></Case>
              <Case :id="30"></Case>
              <Case :id="29"></Case>
              <Case :id="28"></Case>
              <Case :id="27"></Case>
              <Case :id="26"></Case>

              <Case :id="-20"></Case>
              <Case :id="-21"></Case>
              <Case :id="-22"></Case>
              <Case :id="-23"></Case>
              <Case :id="-24"></Case>
              <Case :id="25"></Case>

              <Case :id="19"></Case>
              <Case :id="20"></Case>
              <Case :id="21"></Case>
              <Case :id="22"></Case>
              <Case :id="23"></Case>
              <Case :id="24"></Case>
            </div>
            <div
              class="b-c"
              style="
                width: calc(var(--unit-case) * 6);
                height: calc(var(--unit-case) * 6);
              "
            >
              <div
                style="
                  width: calc(var(--unit-case) * 4);
                  height: calc(var(--unit-case) * 4);
                "
                class="g"
              >
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="D1"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="D2"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="D3"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  style="
                    width: calc(var(--unit-case) * 2);
                    height: calc(var(--unit-case) * 2);
                  "
                  class="b-fs b-c"
                >
                  <div
                    data-castle-id="D4"
                    style="
                      width: calc(var(--unit-case));
                      height: calc(var(--unit-case));
                    "
                  ></div>
                </div>
                <div
                  v-if="getPlayerRank('D')"
                  style="font-size: 50px"
                  class="abs u-13 -r-4 c-20 c-orng-t o-9 b-c"
                >
                  {{ getPlayerRank("D") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-y-5 b b-j-sb b-a-c w-f">
        <Dice
          v-if="game.players.C.enabled"
          :enabled="player === 'C'"
          :color="game.players.C.pawns.config.color"
          :result="randemResult"
          @click="rollDice"
        ></Dice>
        <div class="h-8 w-f b-c b-j-sb">
          <i
            class="-i u-8 o-7"
            v-if="game.players.C.bot && game.players.C.enabled"
            >adb</i
          >
          <i
            class="-i u-8 o-7"
            v-if="game.players.D.bot && game.players.D.enabled"
            >adb</i
          >
        </div>
        <Dice
          v-if="game.players.D.enabled"
          :enabled="player === 'D'"
          :color="game.players.D.pawns.config.color"
          :result="randemResult"
          @click="rollDice"
        ></Dice>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState, mapMutations } from 'vuex'

// import SwpWidget from './widgets/kimai/Swp'
// import CateCard from './widgets/cates/CateCard'
import Dice from './widgets/Dice'
import Case from './widgets/Case'
import Pawn from './widgets/Pawn'
// const axios = require('axios')
class Pops {
  constructor () {
    this.leafs = []
    this._init()
  }

  _init () {
    this.rootElement =
      document.querySelector('#pops-root') || document.createElement('div')
    this.rootElement.setAttribute('id', 'pops-root')
    this.rootElement.style.setProperty('max-width', '100%')
    this.rootElement.style.setProperty('overflow-y', 'auto')
    this.rootElement.style.setProperty('max-height', '100vh')
    // this.rootElement.style.setProperty("pointer-events", "none");
    this.rootElement.classList.add('fxd', '-z-3', '.t', '.e', 'p-4')
    document.body.appendChild(this.rootElement)
  }

  show (message, color = 'rgb(255, 203, 0)') {
    const leaf = document.createElement('div')
    leaf.classList.add('m-b-4', 'p-x-6', 'p-y-5', '-r-2', 'e', 'c-bl')
    leaf.style.setProperty('--c-bl', color)
    // leaf.style.setProperty("pointer-events", "all");
    leaf.innerHTML = message
    this.leafs.unshift(leaf)
    this.rootElement.appendChild(leaf)

    leaf.addEventListener('click', () => {
      leaf.remove()
    })
    return leaf
  }
}
window.pops = new Pops()

export default {
  data () {
    return {
      area: [
        // [-1, -1, -1, -1, -1, -1, 59, 60, 61, -1, -1, -1, -1, -1, -1],
        // [-1,-43, -1, -1,-42, -1, 58,600, 10, -1,-10, -1, -1,-13, -1],
        // [-1, -1, -1, -1, -1, -1, 57,601, 11, -1, -1, -1, -1, -1, -1],
        // [-1, -1, -1, -1, -1, -1, 56,602, 12, -1, -1, -1, -1, -1, -1],
        // [-1,-40, -1, -1,-41, -1, 55,603, 13, -1,-11, -1, -1,-12, -1],
        // [-1, -1, -1, -1, -1, -1, 54,604, 14, -1, -1, -1, -1, -1, -1],
        // [48, 49, 50, 51, 52, 53, -1,605, -1, 15, 16, 17, 18, 19, 20],
        // [47,470,471,472,473,474,475, -1,215,214,213,212,211,210, 21],
        // [46, 45, 44, 43, 42, 41, -1,345, -1, 27, 26, 25, 24, 23, 22],
        // [-1, -1, -1, -1, -1, -1, 40,344, 28, -1, -1, -1, -1, -1, -1],
        // [-1,-32, -1, -1,-31, -1, 39,343, 29, -1,-21, -1, -1,-20, -1],
        // [-1, -1, -1, -1, -1, -1, 38,342, 30, -1, -1, -1, -1, -1, -1],
        // [-1, -1, -1, -1, -1, -1, 37,341, 31, -1, -1, -1, -1, -1, -1],
        // [-1,-33, -1, -1,-30, -1, 36,340, 32, -1,-22, -1, -1,-23, -1],
        // [-1, -1, -1, -1, -1, -1, 35, 34, 33, -1, -1, -1, -1, -1, -1]
        [-1, -1, -1, -1, -1, -1, 59, 60, 61, -1, -1, -1, -1, -1, -1],
        [-1, -43, -1, -1, -42, -1, 58, 600, 10, -1, -10, -1, -1, -13, -1],
        [-1, -1, -1, -1, -1, -1, 57, 601, 11, -1, -1, -1, -1, -1, -1],
        [-1, -1, -1, -1, -1, -1, 56, 602, 12, -1, -1, -1, -1, -1, -1],
        [-1, -40, -1, -1, -41, -1, 55, 603, 13, -1, -11, -1, -1, -12, -1],
        [-1, -1, -1, -1, -1, -1, 54, 604, 14, -1, -1, -1, -1, -1, -1],
        [48, 49, 50, 51, 52, 53, -1, 605, -1, 15, 16, 17, 18, 19, 20],
        [
          47,
          470,
          471,
          472,
          473,
          474,
          475,
          -1,
          215,
          214,
          213,
          212,
          211,
          210,
          21
        ],
        [46, 45, 44, 43, 42, 41, -1, 345, -1, 27, 26, 25, 24, 23, 22],
        [-1, -1, -1, -1, -1, -1, 40, 344, 28, -1, -1, -1, -1, -1, -1],
        [-1, -32, -1, -1, -31, -1, 39, 343, 29, -1, -21, -1, -1, -20, -1],
        [-1, -1, -1, -1, -1, -1, 38, 342, 30, -1, -1, -1, -1, -1, -1],
        [-1, -1, -1, -1, -1, -1, 37, 341, 31, -1, -1, -1, -1, -1, -1],
        [-1, -33, -1, -1, -30, -1, 36, 340, 32, -1, -22, -1, -1, -23, -1],
        [-1, -1, -1, -1, -1, -1, 35, 34, 33, -1, -1, -1, -1, -1, -1]
      ],
      game: null,
      gameBase: {
        state: 'BOOT',
        speed: 1,
        winers: [],
        players: {
          A: {
            start: 40,
            end: 38,
            enabled: true,
            bot: false,
            pawns: {
              config: {
                color: 'c-bl'
              },
              completed: 0,
              list: {
                1: 'A1',
                2: 'A2',
                3: 'A3',
                4: 'A4'
              },
              pos: {
                1: 1,
                2: 1,
                3: 1,
                4: 1
              },
              potentials: []
            }
          },
          B: {
            start: 1,
            end: 51,
            enabled: true,
            bot: false,
            pawns: {
              config: {
                color: 'c-rd'
              },
              completed: 0,
              list: {
                1: 'B1',
                2: 'B2',
                3: 'B3',
                4: 'B4'
              },
              pos: {
                1: 1,
                2: 1,
                3: 1,
                4: 1
              },
              potentials: []
            }
          },
          C: {
            start: 27,
            end: 25,
            enabled: true,
            bot: false,
            pawns: {
              config: {
                color: 'c-grn'
              },
              completed: 0,
              list: {
                1: 'C1',
                2: 'C2',
                3: 'C3',
                4: 'C4'
              },
              pos: {
                1: 1,
                2: 1,
                3: 1,
                4: 1
              },
              potentials: []
            }
          },
          D: {
            start: 14,
            end: 12,
            enabled: true,
            bot: false,
            pawns: {
              config: {
                color: 'c-orng'
              },
              completed: 0,
              list: {
                1: 'D1',
                2: 'D2',
                3: 'D3',
                4: 'D4'
              },
              pos: {
                1: 1,
                2: 1,
                3: 1,
                4: 1
              },
              potentials: []
            }
          }
        }
      },
      cache: {},
      player: 'A',
      step: 1,
      chance: 1,
      OUT_NUMBER: 6,
      isMoving: false,
      isSettingsOpen: true,
      player2Score: 0,
      randemResult: null,
      activeSideImageId: 1,
      isMenuOpen: false,
      isPageReady: false
    }
  },
  components: {
    // SwpWidget,
    Pawn,
    Case,
    Dice
  },
  computed: {
    canStart: function () {
      return (
        Object.values(this.game.players).filter((x) => x.enabled).length >= 2
      )
    },
    playersLength: function () {
      return Object.values(this.game.players).filter((x) => x.enabled).length
    },

    safeCases: function () {
      return [
        this.game.players.A.start,
        this.game.players.B.start,
        this.game.players.C.start,
        this.game.players.D.start,
        this.game.players.A.start + 7,
        this.game.players.B.start + 7,
        this.game.players.C.start + 7,
        this.game.players.D.start + 7
      ]
    },
    pawns: function () {
      return [
        ...this.game.players.A.pawns.list,
        ...this.game.players.B.pawns.list,
        ...this.game.players.C.pawns.list,
        ...this.game.players.D.pawns.list
      ]
    }
  },
  watch: {
    // $route (to, from) {
    // this.$store.commit('config', to.query)
    // },

    '$store.state.theme.brightness': function (to) {
      var root = document.querySelector('.--env')
      localStorage.theme = to
      if (to === 'dark') {
        root.classList.add('--dark')
        root.classList.remove('--light')
      } else {
        root.classList.add('--light')
        root.classList.remove('--dark')
      }
    }
  },
  methods: {
    toggleSpeed () {
      var speeds = [0.1, 0.2, 0.3, 0.5, 0.8, 1, 1.2, 1.3, 1.5, 2, 5]
      var nextIndex = speeds.indexOf(this.game.speed)
      if (speeds[nextIndex + 1]) {
        this.game.speed = speeds[nextIndex + 1]
      } else {
        this.game.speed = speeds[0]
      }
    },
    async start () {
      this.game.state = 'STARTED'
      this.selectPlayer('A')
      if (this.game.players[this.player].bot) {
        await new Promise((resolve) =>
          setTimeout(resolve, this.game.speed * 500)
        )
        this.genRandomResult(true)
      }
    },
    getPlayerRank (player) {
      if (this.game.winers.includes(player)) {
        var index = this.game.winers.indexOf(player)
        if (index === 0) {
          return '👑'
        } else if (index === 1) {
          return '🥈'
        } else if (index === 2) {
          return '🥉'
        } else if (index === 3) {
          return '🏅'
        }
      }
      return false
    },
    getPawnIndexInCase (_player, _pawn, _case) {
      var pawns = []

      for (const __player in this.game.players) {
        for (const __pawn in this.game.players[__player].pawns.list) {
          if (
            this.game.players[__player].pawns.list[__pawn] ===
            this.game.players[_player].pawns.list[_pawn]
          ) {
            pawns.push(__player + __pawn)
          }
        }
      }

      // console.log(pawns, _player, _pawn, _case)

      return {
        index: pawns.indexOf(_player + _pawn),
        pawns: pawns
      }
    },
    checkPlayerIfWin (player) {
      if (this.game.players[this.player].pawns.completed === 4) {
        if (!this.game.winers.includes(player)) {
          this.game.winers.push(player)
        }
        return true
      }
      return false
    },
    rollDice () {
      if (!this.game.players[this.player].bot) {
        this.genRandomResult()
      }
    },
    async genRandomResult (bot = false) {
      if (this.step !== 1) {
        return
      }
      this.randemResult = Math.floor(Math.random() * 6) + 1 // ((Date.now().toString()[12] / 2).toString().split('.')[0]) * 1 + 1
      this.step = 2
      await new Promise((resolve) =>
        setTimeout(resolve, this.game.speed * 200)
      )

      const player = this.game.players[this.player]
      player.pawns.potentials = this.getPlayerPotentials(
        this.player,
        this.randemResult
      )
      const playerPotentialsArreyValues = Object.values(
        player.pawns.potentials
      )
      const playerPotentialsArreyKeys = Object.keys(player.pawns.potentials)

      if (!playerPotentialsArreyKeys.length) {
        return !this.nextPlayer(this.player)
      } else if (playerPotentialsArreyKeys.length === 1 || bot) {
        var selectedRandomPawn = Math.floor(
          Math.random() * playerPotentialsArreyKeys.length
        )
        this.movePawn(
          playerPotentialsArreyValues[selectedRandomPawn],
          this.player,
          player.pawns.list[playerPotentialsArreyValues[selectedRandomPawn]]
        )
      }
    },
    movePawn (id, player, place) {
      place = +place || this.game.players[player].start
      if (
        this.player === player &&
        this.randemResult &&
        place !== this.game.players[player].start * -1 - 3
      ) {
        this.moveDirectly(id, player, place, this.randemResult)
      }
    },
    async moveDirectly (id, player, place, to) {
      if (this.step === 1 || this.isMoving) {
        return
      }
      var nextPlace = this.getNextPlace(player, place, to).next
      var potentialPlace = this.getPawnPotential(id, player, place, nextPlace)
      var potentialPlaceArrey = Object.keys(potentialPlace)
      // console.log(-(this.game.players[player].start - 4))
      // console.log('nextPlace', nextPlace)
      if (
        to === this.OUT_NUMBER ||
        nextPlace === -(this.game.players[player].end - 6)
      ) {
        this.chance++
      }
      if (!potentialPlaceArrey.length) {
        return false
      } else {
        if (potentialPlace[this.game.players[player].start]) {
          await this.animatePawnTo(
            id,
            player,
            place,
            this.game.players[player].start,
            0
          ).then(() => {
            return !this.nextPlayer()
          })
        } else if (potentialPlace[nextPlace]) {
          await this.animatePawnTo(id, player, place, nextPlace).then(() => {
            this.killPawns(id, player, place, nextPlace)
            return !this.nextPlayer(player)
          })
        }
      }
    },
    async animatePawnTo (
      id,
      player,
      place,
      nextPlace,
      result = 1,
      _loop = true
    ) {
      if (this.game.players[player].pawns.completed === 4) {
        window.pops.show('Player ' + player + ' Win!')
        return
      }
      this.isMoving = true
      var nextStepProvider = this.getNextPlace(player, place, result)
      var nextStep = nextStepProvider.next
      this.game.players[player].pawns.list[id] = nextStep

      await new Promise((resolve) =>
        setTimeout(resolve, this.game.speed * 300)
      )
      if (nextStep !== nextPlace && _loop) {
        await this.animatePawnTo(id, player, nextStep, nextPlace)
      }

      this.isMoving = false
      if (!this.checkIfPawnCanMoveTo(id, player, place, nextStep + 1)) {
        this.game.players[player].pawns.completed++
      }
    },
    getPawnElement (player, pawnId) {
      return document.querySelector('[data-pawn-id="' + player + pawnId + '"]')
    },
    getNextPlace (player, place, result) {
      var nextPlace = place + result
      var playerEnd = this.game.players[player].end
      var ended = false
      var restarted = false

      if (nextPlace > 52 && player !== 'B') {
        nextPlace = place + result - 52
        restarted = true
      }
      if (place <= playerEnd && nextPlace > playerEnd) {
        nextPlace = -(playerEnd - (result - (playerEnd - place)))
        ended = true
      }
      return {
        next: nextPlace,
        ended: ended,
        restarted: restarted
      }
    },
    nextPlayer (player = this.player) {
      this.checkPlayerIfWin(player)
      this.chance = Math.max(this.chance - 1, 0)
      if (this.chance === 0) {
        if (player === 'A') {
          this.selectPlayer('B')
        } else if (player === 'B') {
          this.selectPlayer('D')
        } else if (player === 'D') {
          this.selectPlayer('C')
        } else if (player === 'C') {
          this.selectPlayer('A')
        }
      } else {
        this.selectPlayer(player)
      }
      return true
    },
    async selectPlayer (player) {
      this.player = player
      this.chance = 1
      this.step = 1
      this.randemResult = null
      if (
        this.checkPlayerIfWin(player) ||
        !this.game.players[this.player].enabled
      ) {
        if (this.game.winers.length === this.playersLength) {
          this.gameOver()
          return false
        }
        return this.nextPlayer()
      }
      if (this.game.players[this.player].bot) {
        await new Promise((resolve) =>
          setTimeout(resolve, this.game.speed * 500)
        )
        this.genRandomResult(true)
      }
      return true
    },
    getPlayerPotentials (player, result) {
      var playerPotentials = {}
      var playerData = this.game.players[player]

      for (const __pawn in playerData.pawns.list) {
        var place = this.game.players[player].pawns.list[__pawn]
        var nextPlace = this.getNextPlace(player, place, result).next
        var pawnPotential = this.getPawnPotential(
          __pawn,
          player,
          place,
          nextPlace
        )
        playerPotentials = Object.assign(playerPotentials, pawnPotential)
      }

      return playerPotentials
    },
    getPawnPotential (pawnId, player, place, nextPlace) {
      var potentialPlaces = {}
      const _np = this.checkIfPawnCanMoveTo(pawnId, player, place, nextPlace)
      if (
        this.game.players[player].pawns.list[pawnId].toString()[0] === player
      ) {
        if (this.randemResult === this.OUT_NUMBER && _np) {
          potentialPlaces[this.game.players[player].start] = pawnId
        }
      } else {
        if (_np) {
          potentialPlaces[nextPlace] = pawnId
        }
      }
      return potentialPlaces
    },
    checkIfPawnCanMoveTo (pawnId, player, place, nextPlace) {
      var playerData = this.game.players[player]
      if (
        place < playerData.end &&
        nextPlace <= playerData.end &&
        nextPlace <= 0
      ) {
        if (nextPlace > -(playerData.end - 6)) {
          return false
        }
      }
      return true
    },
    killPawns (id, player, place, nextPlace) {
      if (this.safeCases.includes(nextPlace)) {
        return false
      }
      for (const __player in this.game.players) {
        var _player = this.game.players[__player]
        for (const __pawn in _player.pawns.list) {
          var _pawn = this.game.players[__player].pawns.list[__pawn]

          if (__player !== player) {
            if (_pawn === nextPlace) {
              this.game.players[__player].pawns.list[__pawn] =
                __player + __pawn
              this.chance++
            }
          }
        }
      }
    },
    moveStep (id, player, place, i, to) {
      setTimeout(() => {
        var nextPlace = to > 52 ? to - 52 : to
        // var inextPlace = to > 52 ? (to - 52) : to
        this.game.players[player].pawns.list[id] = i
        if (place + i < nextPlace) {
          this.moveDirectly(
            id,
            player,
            place,
            i + 1,
            place + this.randemResult
          )
        }
      }, this.game.speed * 500)
    },
    gameOver () {
      this.game.state = 'OVER'
    },
    reset () {
      delete this.game
      this.game = JSON.parse(JSON.stringify(this.gameBase))
    },
    restart () {
      // setTimeout(() => {
      this.game.state = 'BOOT'
      this.step = 1
      // this.game.players = { ...this.gameBase.players }
      this.reset()
      // this.start()
      // }, 0)
    },
    pause () {
      this.game.state = 'PAUSE'
    },
    async continueGame () {
      this.game.state = 'STARTED'

      if (this.game.players[this.player].bot) {
        await new Promise((resolve) =>
          setTimeout(resolve, this.game.speed * 500)
        )
        this.genRandomResult(true)
      }
    }
  },
  created () {
    // try {
    //   window.screen.orientation.lock('landscape')
    // } catch (error) {
    //   alert(error)
    // }
    this.reset()
    // setInterval(() => {
    //   if (this.activeSideImageId === 4) {
    //     this.activeSideImageId = 0
    //   }
    //   this.activeSideImageId++
    // }, 4000)
  }
}
</script>

<style lang="scss">
@import "../../../opensource/web/kimai/src/sass/import.scss";
@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;600&display=swap");
// @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
//   html {
//     transform: rotate(-90deg);
//     transform-origin: left top;
//     width: 100vh !important;
//     height: 100vw !important;
//     overflow: hidden;
//     position: absolute;
//     top: 100%;
//     left: 0;
//   }
//   #root-env {
//     width: 100vh !important;
//     height: 100vw !important;
//   }
// }
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
//
html {
  font-family: sans-serif;
}
.--env {
  --theme-font-edit-size: 0px;
  font-size: 20px;
}

.--dark {
  --c-s: #030031;
  --c-p: rgb(255, 188, 0);
}

.--light {
  --c-s: rgb(3, 0, 49);
  --c-p: rgb(255, 188, 0);
}
//@at-root

.colored-border {
  border-right-color: var(--c-rd) !important;
  border-left-color: var(--c-grn) !important;
  border-top-color: var(--c-orng) !important;
  border-bottom-color: var(--c-bl) !important;
}
</style>
